import React from 'react'
import {
  Form, Radio, Button, Table, Header, Pagination, Label,
  Input, Tab, Checkbox, Dimmer, Dropdown, Icon
} from 'semantic-ui-react'
import './ReportsView.scss'
import {REPORT_TYPES, REPORT_MODES} from "../../../constants";
import _ from 'lodash';
import moment from 'moment'

import {DateRangePicker, Calendar} from 'react-date-range';

import 'react-dates/initialize';
import {DateRangePicker as _DateRangePicker} from 'react-dates';

import ReportsSettings from '../containers/ReportsSettingsContainer'

import {getLanguageScope, S} from '../../../helpers'

const _i18n = getLanguageScope('reports');

export default class ReportsView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      currentHistoryPage: 1,
      filterFocusedInput: null,
      activePageIndex: 0
    };

    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSingleRange = this.handleSingleRange.bind(this);
    this.onFilterDatesUpdate = this.onFilterDatesUpdate.bind(this);
    this.onFilterDatesChanged = this.onFilterDatesChanged.bind(this);
    this.loadReports = this.loadReports.bind(this);
  }

  componentDidMount() {
    const {loadAutomaticReportConfig} = this.props;

    this.loadReports();
    loadAutomaticReportConfig && loadAutomaticReportConfig();
  }

  onChangePane = (event, data) => {
    this.setState(() => ({activePageIndex: data.activeIndex}))
  };

  loadReports() {
    const {loadReports} = this.props;
    loadReports && loadReports();
  }

  handlePaginationChange(e, {activePage}) {
    const {changeActiveHistoryPage} = this.props;

    changeActiveHistoryPage && changeActiveHistoryPage(activePage)
  };

  getLabelColor(type) {
    let color = 'grey';

    if (type === REPORT_TYPES.DAILY) {
      color = 'teal'
    }

    if (type === REPORT_TYPES.WEEKLY) {
      color = 'blue'
    }

    if (type === REPORT_TYPES.MONTHLY) {
      color = 'violet'
    }

    if (type === REPORT_TYPES.CUSTOM) {
      color = 'olive'
    }

    return color;
  }

  renderReportsTable() {
    const {reports, history_active_page, total_pages, printReceipt, filter_start_date, filter_end_date} = this.props;
    const {filterFocusedInput} = this.state;

    let reportItems = _.map((reports || false), (r, key) => {
      return (
        <Table.Row key={key}>
          <Table.Cell>
            <Label color={this.getLabelColor(r.type)} ribbon>
              {r.type} {r.mode}
            </Label>
          </Table.Cell>
          <Table.Cell>
            {moment(r.created_date).format('MM/DD/YYYY HH:mm A')}
          </Table.Cell>
          <Table.Cell>{moment(r.from).format('MM/DD/YYYY')} - {moment(r.to).format('MM/DD/YYYY')}</Table.Cell>
          <Table.Cell>
            <Button className={'center-block'} inverted onClick={() => printReceipt(r.receipt_url)}
                    content={_i18n('print_report')}/>
            <Button inverted icon='file pdf' onClick={() => window.open(r.receipt_url, '_blank')} />
          </Table.Cell>
        </Table.Row>
      )
    });

    if (!(reportItems && reportItems.length)) {
      reportItems.push(
        <Table.Row key={-1}>
          <Table.Cell colSpan={4}>
            <Header as={'h4'} style={{color: 'white'}} content={_i18n('no_reports')}/>
          </Table.Cell>
        </Table.Row>
      )
    }

    return (
      <div>
        <Header as={'h3'} content={_i18n('reports_table_title')}/>

        <Table color={'grey'} inverted>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <_DateRangePicker
                  startDate={filter_start_date}
                  startDateId="filter_start_date"
                  endDate={filter_end_date}
                  small={true}
                  numberOfMonths={1}
                  minimumNights={0}
                  isOutsideRange={(day) => day > moment()}
                  hideKeyboardShortcutsPanel={true}
                  endDateId="filter_end_date"
                  onDatesChange={this.onFilterDatesChanged}
                  focusedInput={filterFocusedInput}
                  onFocusChange={filterFocusedInput => this.setState({filterFocusedInput})}
                  onClose={this.onFilterDatesUpdate}
                />
              </Table.HeaderCell>
              <Table.HeaderCell>
                {_i18n('created_date')}
              </Table.HeaderCell>
              <Table.HeaderCell>{_i18n('report_dates')}</Table.HeaderCell>
              <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {reportItems}
          </Table.Body>
        </Table>

        <Pagination
          activePage={history_active_page}
          onPageChange={this.handlePaginationChange}
          firstItem={null}
          lastItem={null}
          pointing
          secondary
          className='center-pagination'
          totalPages={total_pages}
        />

      </div>
    )
  }

  async onFilterDatesChanged({startDate, endDate}) {
    const {changeFilterDates} = this.props;

    const from = startDate && startDate.format('YYYY-MM-DD');
    const to = endDate && endDate.format('YYYY-MM-DD');

    return await changeFilterDates({startDate: from, endDate: to});
  }

  async onFilterDatesUpdate({startDate, endDate}) {
    await this.onFilterDatesChanged({startDate, endDate});

    this.loadReports()
  }

  renderDateRangePicker() {
    const {type, mode} = this.props;
    const {startDate, endDate} = this.state;

    if (type !== REPORT_TYPES.CUSTOM) return null;

    if (mode === REPORT_MODES.DETAILED) {
      return <Calendar
        maxDate={new Date()}
        date={startDate}
        onChange={this.handleSingleRange}
      />
    }

    return (
      <DateRangePicker
        months={1}
        maxDate={new Date()}
        inputRanges={[]}
        direction={'horizontal'}
        ranges={[{
          startDate: startDate,
          endDate: endDate,
          key: 'selection',
        }]}
        onChange={this.handleSelect}
      />
    )
  }

  handleSelect(ranges) {
    const selection = ranges.selection || {};

    this.setState(() => {
      return {
        startDate: selection.startDate,
        endDate: selection.endDate
      }
    });
  }

  handleSingleRange(date) {
    this.setState(() => {
      return {
        startDate: date,
        endDate: date
      }
    })
  }

  renderManualReportForm() {
    const {type, mode, changeReportMode, changeReportType, generateReport, loading} = this.props;
    const {startDate, endDate} = this.state;

    return (
      <Form loading={loading}>
        <Form.Group inline>
          <Form.Field
            control={Radio}
            label={_i18n('detailed_report')}
            value={REPORT_MODES.DETAILED}
            checked={mode === REPORT_MODES.DETAILED}
            onChange={() => changeReportMode(REPORT_MODES.DETAILED)}
          />
          <Form.Field
            control={Radio}
            label={_i18n('report_summary')}
            value={REPORT_MODES.SUMMARY}
            checked={mode === REPORT_MODES.SUMMARY}
            onChange={() => changeReportMode(REPORT_MODES.SUMMARY)}
          />
        </Form.Group>
        <Form.Group inline>
          <Form.Field
            control={Radio}
            label={_i18n('daily_report')}
            value={REPORT_TYPES.DAILY}
            checked={type === REPORT_TYPES.DAILY}
            onChange={() => changeReportType(REPORT_TYPES.DAILY)}
          />
          <Form.Field
            control={Radio}
            label={_i18n('weekly_report')}
            disabled={mode === REPORT_MODES.DETAILED}
            value={REPORT_TYPES.WEEKLY}
            checked={type === REPORT_TYPES.WEEKLY}
            onChange={() => changeReportType(REPORT_TYPES.WEEKLY)}
          />
          <Form.Field
            control={Radio}
            label={_i18n('monthly_report')}
            disabled={mode === REPORT_MODES.DETAILED}
            value={REPORT_TYPES.MONTHLY}
            checked={type === REPORT_TYPES.MONTHLY}
            onChange={() => changeReportType(REPORT_TYPES.MONTHLY)}
          />
          <Form.Field
            control={Radio}
            label={_i18n('custom_dates_report')}
            value={REPORT_TYPES.CUSTOM}
            checked={type === REPORT_TYPES.CUSTOM}
            onChange={() => changeReportType(REPORT_TYPES.CUSTOM)}
          />
        </Form.Group>

        {this.renderDateRangePicker()}

        <Form.Group inline>
          <Button secondary onClick={() => generateReport(mode, startDate, endDate)}
                  content={_i18n('generate_report')}/>
        </Form.Group>
      </Form>
    )
  }

  renderAutomaticReportForm() {
    const {
      automatic_daily_enabled, automatic_days, hide_days_of_week, automatic_email_input, automatic_emails,
      switchAutomaticReport, changeDayOfWeekOnAutomaticReport, addAutomaticEmail, removeAutomaticEmail, changeEmailInput
    } = this.props;

    return (
      <Form className={'day_of_week_form'}>
        <Form.Field>
          <Checkbox toggle onChange={switchAutomaticReport} checked={automatic_daily_enabled}
                    label={_i18n('enable_automatic_report')}/>
        </Form.Field>

        <Dimmer.Dimmable dimmed={hide_days_of_week}>

          <Dimmer inverted active={hide_days_of_week}/>

          <Form.Field>
            <label>{_i18n('select_day_of_week')}</label>
            <Button.Group basic toggle={true} widths='7'>
              {_.map(Array(7), (__, index) => (
                <Button
                  key={index}
                  active={_.includes(automatic_days, index)}
                  onClick={() => changeDayOfWeekOnAutomaticReport(index)}>
                  {_i18n(`week_day_${index}`)}
                </Button>
              ))}
            </Button.Group>
          </Form.Field>

          <Form.Group widths='equal'>
            <Form.Field>
              <Form.Input
                icon='mail'
                type='email'
                name='email'
                label={_i18n('add_emails')}
                value={automatic_email_input}
                onChange={(e, {name, value}) => changeEmailInput(value)}
                iconPosition='left'
                action={{
                  color: 'black', content: _i18n('submit'),
                  onClick: () => addAutomaticEmail()
                }}
                placeholder={_i18n('add_email')}
              />
            </Form.Field>
            <Form.Field inline>
              {_.map(automatic_emails, (v, k) =>
                <Label key={k} style={{marginTop: 10}}>
                  {v}<Icon name='delete' onClick={() => removeAutomaticEmail(v)}/>
                </Label>
              )}
            </Form.Field>
          </Form.Group>

        </Dimmer.Dimmable>
      </Form>
    )
  }

  getPanes = () => {
    const {configure_devices} = this.props;
    const panes = [];

    panes.push({
        menuItem: {key: 'manual', icon: 'hand paper', content: _i18n('manual_reports')},
        render: () => <Tab.Pane className={'report-tab'} attached={false}>{this.renderManualReportForm()}</Tab.Pane>
      },
      {
        menuItem: {key: 'automatic', icon: 'recycle', content: _i18n('automatic_reports')},
        render: () => <Tab.Pane className={'report-tab'} attached={false}>{this.renderAutomaticReportForm()}</Tab.Pane>
      });

    if (configure_devices) {
      panes.push(
        {
          menuItem: {key: 'settings', icon: 'settings', content: _i18n('settings_reports')},
          render: () =>
            <Tab.Pane className={'report-tab'} attached={false}>
              <ReportsSettings/>
            </Tab.Pane>
        }
      )
    }

    return panes;
  };

  render() {
    const {activePageIndex} = this.state;

    return (
      <div>
        <Tab menu={{secondary: true}} activeIndex={activePageIndex} onTabChange={this.onChangePane} panes={this.getPanes()}/>
        {activePageIndex !== 2 ? this.renderReportsTable() : null}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Reports/components/ReportsView.js